(function ($) {

	var element = '[data-post-list-entry]',
		$list,
		$filters = {},
		filter_term = '';

	/**
	 * Updates the list to match the selected filter
	 * (Hides entries which don't match)
	 */
	var filterList = function (event) {

		// Combine all of the individual class names to make a single string,
		// which will then be compared against the class names on the elements
		filter_terms = [];
		$filters.each(function () {
			if ((filter_value = $(this).data('value').replace(/^\./g, '')) !== '') {
				filter_terms.push(filter_value);
			}
		});
		filter_term = filter_terms.join('.');

		if (filter_term === 'all') {
			$(element).removeClass('hide');
		} else {
			$(element).addClass('hide');
			$('.' + filter_term).removeClass('hide');
		}

		storeSelection($filters, 'data-postlist-filter', 'select');
		
	};

	/**
	 * Do all the things
	 */

	$list = $('[data-filtered-postlist]');
	$filters = $('[data-postlist-filter]');

	$filters.on('datachange.listfilter', filterList);

	getPrecog($filters, 'post_list_filter', 'select');

}(jQuery));